import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { SourcingTemplateEditPage } from '@/areas/sourcing-scenarios/SourcingTemplates/SourcingTemplateEditPage';
import { canManageSourcingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/sourcing/$sourcingTemplateId/edit')({
    staticData: { access: { permissions: canManageSourcingTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <SourcingTemplateEditPage {...pathParams} />;
}
